export var VOID = -1;
export var PRIMITIVE = 0;
export var ARRAY = 1;
export var OBJECT = 2;
export var DATE = 3;
export var REGEXP = 4;
export var MAP = 5;
export var SET = 6;
export var ERROR = 7;
export var BIGINT = 8;
// export const SYMBOL = 9;